import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetProductInventoryState, getProductInventory as onGetProductInventories, addNewProductInventory as onAddNewProductInventory, updateProductInventory as onUpdateProductInventory, deleteProductInventory as onDeleteProductInventory, getProductInventoryLoading } from "../../../store/productInventory/action";
import { resetProductInventoryBranchState, getProductInventoryBranch as onGetProductInventoryBranches, addNewProductInventoryBranch as onAddNewProductInventoryBranch, updateProductInventoryBranch as onUpdateProductInventoryBranch, getProductInventoryBranchLoading } from "../../../store/productInventoryBranch/action";
import { resetTransferState, getTransfer as onGetTransfers, addNewTransfer as onAddNewTransfer, updateTransfer as onUpdateTransfer, deleteTransfer as onDeleteTransfer, getTransferLoading, resetTransferCreateState } from "../../../store/transfer/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { resetClientState, getClient } from "../../../store/client/action";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";

const Transfer = () => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const [productInventoryList, setProductInventoryList] = useState([]);
  const [productSelectInventoryList, setProductSelectInventoryList] = useState([]);
  const [productInventoryDetailItem, setProductInventoryDetailItem] = useState([]);

  const dispatch = useDispatch();

  const { productInventoryLoading, productInventories, isProductInventoryCreated, isProductInventorySuccess,
    clients, clientLoading, transfers, transferAdded, isTransferCreated, isTransferSuccess,
    loading, error, companies, companyLoading, shipmentMethods, shipmentMethodLoading,
    shipmentCarriers, shipmentCarrierLoading, branches, branchLoading, productVarians, productVarianLoading,
    productInventoryBranches, productInventoryBranchAdded, isProductInventoryBranchCreated, isProductInventoryBranchSuccess, productInventoryBranchloading } = useSelector((state) => ({
      transferAdded: state.Transfer.transferAdded,
      transfers: state.Transfer.transfers,
      isTransferCreated: state.Transfer.isTransferCreated,
      isTransferSuccess: state.Transfer.isTransferSuccess,
      loading: state.Transfer.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      shipmentMethods: state.ShipmentMethod.shipmentMethods,
      shipmentMethodLoading: state.ShipmentMethod.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
      shipmentCarrierLoading: state.ShipmentCarrier.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
      error: state.Transfer.error,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      productInventories: state.ProductInventory.productInventories,
      isProductInventoryCreated: state.ProductInventory.isProductInventoryCreated,
      isProductInventorySuccess: state.ProductInventory.isProductInventorySuccess,
      productInventoryLoading: state.ProductInventory.loading,
      productInventoryBranchAdded: state.ProductInventoryBranch.productInventoryBranchAdded,
      productInventoryBranches: state.ProductInventoryBranch.productInventoryBranches,
      isProductInventoryBranchCreated: state.ProductInventoryBranch.isProductInventoryBranchCreated,
      isProductInventoryBranchSuccess: state.ProductInventoryBranch.isProductInventoryBranchSuccess,
      productInventoryBranchLoading: state.ProductInventoryBranch.loading,
    }));

  const [transferList, setTransferList] = useState([]);
  const [transfer, setTransfer] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusTransfer, setStatusTransfer] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [productList, setProductList] = useState([]);
  const [transferDetailItem, setTransferDetailItem] = useState([]);
  const [invDocImg, setInvDocImg] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [modalMedia, setModalMedia] = useState(false);

  const [subTot, setSubTot] = useState(0);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredTransfers = transfers;
      if (type !== "all") {
        filteredTransfers = transfers.filter((transfer) => transfer.transfer_status.name === type);
      }
      setTransferList(filteredTransfers);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(resetTransferState());
        dispatch(onGetTransfers({ type: "Delivery" }));
        dispatch(resetProductInventoryBranchState());
        dispatch(onGetProductInventoryBranches());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetBranch(obj.data.companyId);
        handleGetShipmentMethod(obj.data.companyId);
        handleGetShipmentCarrier(obj.data.companyId);
      }
    }
  }, [dispatch, transfers, isSearch]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = useCallback((id) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: id, status: 2 }));
  }, [dispatch]);

  const handleGetShipmentCarrier = (companyId) => {
    dispatch(resetShipmentCarrierState());
    dispatch(getShipmentCarrier({ companyId: companyId, status: 2, type: "Purchase" }));
  }

  const handleGetShipmentMethod = (companyId) => {
    dispatch(resetShipmentMethodState());
    dispatch(getShipmentMethod({ companyId: companyId, status: 2, type: "Purchase" }));
  }

  useEffect(() => {
    if (isProductInventoryCreated) {
      dispatch(resetProductInventoryState());
      dispatch(resetTransferState());
      dispatch(onGetTransfers({ "type": "Delivery" }));
    }
  }, [dispatch, isProductInventoryCreated]);

  useEffect(() => {
    if (!isEmpty(productInventoryBranches)) {
      setProductInventoryList(productInventoryBranches);
    }
  }, [productInventoryBranches]);

  useEffect(() => {
    if (!isEmpty(transfers)) {
      setTransferList(transfers);
    }
  }, [transfers]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var opt = [];
      productVarians.forEach((item, key) => {
        const varian_name = item.pvar_product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        let option_name = "";
        item.pvar_options &&
          item.pvar_options.forEach((i, k) => {
            option_name += i.name + "/";
          });

        var obj = { label: varian_name + " " + option_name.slice(0, -1) + " - " + barcode, name: varian_name + " " + option_name.slice(0, -1), barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId };
        opt.push(obj);
      });
      var option = { options: opt };
      productVarianData.push(option);
      setProductList(productVarianData);
    }
  }, [productVarians]);

  useEffect(() => {
    setTransferList(transfers);
  }, [transfers]);

  useEffect(() => {
    setTransfer(transferAdded);
  }, [transferAdded]);

  const handleValidDate = (date) => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);
    setBranchList(data);
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);


  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      var data = [];
      var opt = [];
      shipmentCarriers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      var data = [];
      var opt = [];
      shipmentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransfer(null);
      setInvDocImg([]);
      setTransferDetailItem([]);
      validation.resetForm();
    } else {
      setProductInventoryList([])
      setModal(true);
    }
  }, [modal, dispatch]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setTransfer(null);
      setTransferDetailItem([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handleInvoiceClick = (arg) => {
    const transfer = arg;
    let transferDetail = [];

    setSubTotal(parseInt(transfer.sub_amount || 0));

    if (transfer.transfer_detail) {
      transfer.transfer_detail.forEach((element) => {
        transferDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          item: { label: `${element.name} - ${element.sku} - ${element.barcode}`, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: parseFloat(element.amount),
          quantity: parseFloat(element.quantity),
          total: parseFloat(element.amount_total),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? parseFloat(element.accepted) : 0,
          rejected: element.rejected ? parseFloat(element.rejected) : 0,
        });
      });
      setTransferDetailItem(transferDetail);
    }
  };


  const handleTransferClick = useCallback((arg, type) => {
    const transfer = arg;
    let transferDetail = [];
    setClientSelect({
      label: transfer.transfer_company.name,
      value: transfer.clientId
    });
    setCompanySelect({
      label: transfer.transfer_client.name,
      value: transfer.companyId
    });

    if (transfer.transfer_detail) {
      transfer.transfer_detail.forEach(element => {
        transferDetail.push({
          detailId: element.id,
          transferId: transfer.id,
          itemId: element.productVarianId,
          item: { label: element.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, price: element.amount, brandId: element.brandId, productId: element.productId },
          amount: parseFloat(element.amount),
          quantity: parseFloat(element.quantity),
          total: parseFloat(element.amount_total),
          name: element.name,
          sku: element.sku,
          barcode: element.barcode,
          brandId: element.brandId,
          accepted: element.accepted ? parseFloat(element.accepted) : 0,
          rejected: element.rejected ? parseFloat(element.rejected) : 0,
        });
      });
      setTransferDetailItem(transferDetail);
    }
    let files = [];
    for (const f of transfer.transfer_file) {
      files.push({ filename: f.filename, originalname: f.originalname })
    }
    setInvDocImg(files);

    setTransfer({
      id: transfer.id,
      description: transfer.description,
      type: transfer.type && { label: transfer.type, value: transfer.type },
      branch: transfer.transfer_branch && { label: transfer.transfer_branch.name, value: transfer.transfer_branch.id },
      company: transfer.transfer_company && transfer.transfer_company.name && { label: transfer.transfer_company.name, value: transfer.transfer_company.id },
      client: transfer.transfer_client && transfer.transfer_client.name && { label: transfer.transfer_client.name, value: transfer.transfer_client.id },
      status: transfer.transfer_status && { label: transfer.transfer_status.name, value: transfer.transfer_status.id },
      clientId: transfer.clientId,
      branchId: transfer.toBranchId,
      salesId: transfer.salesId,
      fromBranchId: transfer.fromBranchId,
      companyId: transfer.companyId,
      shipment_code: transfer.shipment_code,
      transfer_sales: transfer.transfer_sales,
    });

    switch (type) {
      case "detail":
        toggleDetail();
        break;
      default:
        setIsEdit(true);
        toggle();
        break;
    }
  }, [dispatch, handleGetBranch, toggleDetail, toggle]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      filterable: false,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={cellProps.row.original.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light" className="btn-sm" onClick={() => {
                  handleTransferClick(data, "detail");
                  setInfo(data);
                  setModalDetail(true);
                }}><i className="ri-eye-line fs-15"></i></Button>
                <Button color="light" className="btn-sm" onClick={() => {
                  setInfo(data);
                  toggleHistory();
                }}><i className=" ri-history-line fs-15"></i></Button>
                <DropdownToggle tag="button" className="btn btn-sm btn-light" split></DropdownToggle>
                <DropdownMenu >
                  <DropdownItem onClick={() => {
                    data.actionTitle = `You are going to set purchase transaction of ${data.purchase_vendor.name} #${data.code} as COMPLETED`;
                    data.statusTransferId = 5;
                    setTransfer(data);
                    toggleApprove();
                  }}>COMPLETED</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={() => {
                    data.actionTitle = `You are going to CANCEL purchase transaction of ${data.purchase_vendor.name}  #${data.code} `;
                    data.statusTransferId = 6;
                    setTransfer(data);
                    toggleApprove();
                  }}>CANCELED</DropdownItem>
                  <DropdownItem onClick={() => {
                    data.actionTitle = `You are going to set purchase transaction of ${data.purchase_vendor.name} #${data.code} as RETURNED`;
                    data.statuspurchaseId = 7;
                    setTransfer(data);
                    toggleApprove();
                  }}>RETURNED</DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {data.statusId === 2 && (
              <button
                className="btn-label btn btn-sm btn-soft-success fs-12 me-0"
                onClick={() => {
                  handleTransferClick(data);
                }}><i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Ship
              </button>
            )}
          </div>
        );
      },
    },
    {
      Header: "Transfer No",
      accessor: "transaction_no",
      filterable: true,
      Cell: (cellProps) => (
        <Link
          to="#"
          className="fw-semibold"
          onClick={() => {
            let data = cellProps.row.original;
            handleTransferClick(data, "detail");
          }}>
          {cellProps.row.original.transaction_no}
        </Link>
      ),
    },
    {
      id: "Tanggal",
      Header: "Tanggal",
      accessor: "transactionat",
      filterable: false,
      Cell: (data) => {
        return handleValidDate(data.row.original.transactionat);
      },
    },
    {
      Header: "Type",
      accessor: "type",
      filterable: true,
    },
    {
      Header: "Sender",
      accessor: "transfer_from.name",
      filterable: true,
    },
    {
      Header: "Receiver",
      accessor: "transfer_sales.sales_customer.name",
      filterable: true,
    },
    {
      Header: "Qty ",
      accessor: "sub_amount",
      filterable: true,
      Cell: (data) => {
        let qty = 0;
        data.row.original.transfer_detail.forEach((element) => {
          qty += parseFloat(element.quantity);
        });
        return <span className="fw-semibold">{qty}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "transfer_status.name",
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          case "CONFIRMED":
            return <span className="badge text-uppercase badge-soft-secondary">{cell.value}</span>;
          case "SHIPPED":
            return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
          case "RECEIVED":
            return <span className="badge text-uppercase badge-soft-primary">{cell.value}</span>;
          case "COMPLETED":
            return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
          default:
            return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
        }
      },
    }], [handleTransferClick, toggleApprove, toggleHistory]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: transferList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: 'Tanggal',
            desc: true
          }]
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const [subTotal, setSubTotal] = useState(0);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var status = statusTransfer.value ? statusTransfer.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: "requested",
    };
    dispatch(onGetTransfers(param));
  }

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (transfer) {
        transfer.setApprove = true;
        transfer.approval_note = values.approval_note;
        dispatch(onUpdateTransfer(transfer));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (transfer && transfer.id) || 0,
      client: (transfer && transfer.client) || clientSelected,
      company: (transfer && transfer.company) || companySelected,
      branchId: (transfer && transfer.toBranchId) || 0,
      fromBranchId: (transfer && transfer.fromBranchId) || 0,
      salesId: (transfer && transfer.salesId) || 0,
      description: '',
      shipment_code: (transfer && transfer.shipment_code) ?? "",
      branch: (transfer && transfer.branch) ?? "",
      item: transferDetailItem,
    },
    validationSchema: Yup.object({
      shipment_code: Yup.string().required("Please enter shipment code"),
      company: Yup.object().required("Please enter company").nullable(true),
      client: Yup.object().required("Please enter client").nullable(true),
    }),
    onSubmit: (values) => {
      //dispatch(getTransferLoading());
      const addSubmit = {
        transferId: values.id,
        clientId: values.company.value,
        statusId: 3,
        description: values.description,
        transaction_type: "Sales",
        transaction_status: "OUT",
        companyId: values.client.value,
        fromBranchId: values.fromBranchId,
        salesId: values.salesId,
        shipment_code: values.shipment_code,
        inv_detail: JSON.stringify(values.item),
        files: invDocImg.length > 0 ? invDocImg : [],
      }
      dispatch(onAddNewProductInventory(addSubmit));

      validation.resetForm();
      toggle();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = invDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setInvDocImg(newState);
    } else {
      const index = invDocImg.findIndex((fl) => fl.filename === file.filename);
      setInvDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleSelectFile = (file) => {
    setInvDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  useEffect(() => {
    const checkall = document.getElementById("checkBoxAllInventory");
    const resultF = productInventoryList.every(el => el.checked !== true);
    if (checkall !== null) {
      if (resultF) {
        checkall.checked = false;
      }
    }
  }, [productInventoryList])

  document.title = "Transfer Request | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transferList} />
      <Container fluid>
        <BreadCrumb title="Transfer Request" pageTitle="Procurement" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Sales Product Delivery &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn me-2"
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}>
                      <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                    <button type="button" className="btn btn-success me-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-truck-line fs-15 me-1 align-bottom"></i> ALL DELIVERY
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => {
                          toggleTab("4", "SHIPPED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> SHIPPED</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")} onClick={() => {
                          toggleTab("5", "RECEIVED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RECEIVED</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")} onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")} onClick={() => {
                          toggleTab("7", "CANCELED");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")} onClick={() => {
                          toggleTab("8", "RETURNED");
                        }}
                        href="#"><i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Search...`}
                              value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Filter date"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }} /><i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div>
                            <button
                              type="button"
                              className="btn btn-light w-100"
                              onClick={() => {
                                handleFilter();
                              }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Page <strong> {pageIndex + 1} of {pageOptions.length}</strong></Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>{!!isEdit ? "Product Delivery" : "Product Delivery"}</ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                    <ModalBody>
                      <CardBody className="border-less">
                        <Row>

                          <div className="col-lg-7">
                            <div className="mb-3">
                              <div className="input-group">
                                <span className="input-group-text"><i className="fs-20 ri-barcode-box-line"></i></span>
                                <Input name="transaction_reff" id="transaction_reff" className="fs-20 form-control" placeholder="Enter Barcode" type="text"
                                  value={validation.values.transaction_reff}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={validation.touched.transaction_reff && validation.errors.transaction_reff ? true : false} />
                              </div>
                            </div>
                            <Table className="invoice-table table-borderless table-nowrap mb-0 p-0">
                              <thead className="align-middle">
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "5%" }}>#</th>
                                  <th scope="col" style={{ width: "75%" }}>Detail Produk</th>
                                  <th scope="col" className="text-center" style={{ width: "20%" }}>Quantity</th>
                                </tr>
                              </thead>
                              <tbody id="newlink">
                                {transferDetailItem.map((o, i) => {
                                  return (
                                    <tr key={i} id={i} className="product">
                                      <th scope="row" className="product-id">{i + 1}</th>
                                      <td className="text-start vertical-align-center">
                                        {o.item.label}
                                      </td>
                                      <td className="text-center vertical-align-center"><div className="mt-2">{o.quantity}</div></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                          <div className="col-lg-5">
                            <div className="mb-3">
                              {transfer && transfer.transfer_sales && transfer.transfer_sales.sales_customer && (
                                <>
                                  <h5 className="mb-1">Penjualan #{transfer.transfer_sales.code}</h5>
                                  <p>Atas nama <span className="fw-semibold">{transfer.transfer_sales.sales_customer.name}</span></p>
                                </>
                              )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="shipment_code-field" className="form-label">Shipment Code </Label>
                              <Input name="shipment_code" id="shipment_code-field" className="form-control" placeholder="Enter shipment code" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.shipment_code} invalid={validation.touched.shipment_code && validation.errors.shipment_code ? true : false} />
                              {validation.touched.shipment_code && validation.errors.shipment_code ? <FormFeedback type="invalid">{validation.errors.shipment_code}</FormFeedback> : null}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="address-field" className="form-label">Keterangan</Label>
                              <Input type="textarea" className="form-control" id="description" placeholder="Enter Inbound Description " name="description" rows={3}
                                value={validation.values.description ?? ""}
                                onBlur={validation.handleBlur}
                                onChange={validation.handleChange}
                                invalid={validation.touched.description && validation.errors.description ? true : false} />
                              {validation.touched.description && validation.errors.description && (
                                <small className="text-danger" type="invalid">{validation.errors.description}</small>
                              )}
                            </div>
                            <div className="mb-3 d-flex justify-content-between">
                              <Label htmlFor="education" className="form-label">
                                Shipment Document
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  // setMediaType("other");
                                  toggleMedia();
                                }}><i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {invDocImg.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3">
                                    <div className="d-flex justify-content-between mb-3 align-items-center">
                                      <div className="me-2">
                                        <img src={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                      </div>

                                      <div className="text-truncate">{f.filename}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            // e.stopPropagation();
                                            handleDeleteFile(f);
                                          }}>
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </Row>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={() => { setModal(false); }}> Close </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {!!isEdit ? "Update Sales Delivery" : "Add Sales Delivery"}
                            {loading ? (<Spinner size="sm" className="flex-shrink-0" role="status"> Loading... </Spinner>) : ""}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Transfer Histories
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.transfer_history &&
                          info.transfer_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.transfer_history_createdby && item.transfer_history_createdby.employee_image && item.transfer_history_createdby.employee_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.transfer_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.transfer_history_createdby.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.transfer_history_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Change transfer status to <span className="fw-semibold text-info">{item.transfer_history_status.name}</span> with note:
                                        </p>
                                        <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                        <small className="text-muted">{moment(item.createdat, "YYYY/MM/DD HH:mm:ss").fromNow()}</small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light" onClick={() => {
                          setModalHistory(false);
                        }}>
                        Close
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>ACTION CONFIRMATION</ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <h4>Are you sure ?</h4>
                          <p className="fs-16">{transfer && transfer.actionTitle}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Enter Notes If Any" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Transfer Detail
                  </ModalHeader>
                  {transfer !== undefined && transfer !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{transfer.client && transfer.client.label}</h6>
                                  <p className="mb-1">{transfer.company && transfer.company.label}</p>
                                  <p className="mb-1">{transfer.department && transfer.department.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Transfer No</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{transfer.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(transfer.transactionat)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Quantity</th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(productInventoryDetailItem || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o.name}</td>
                                        <td>{o.quantity}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {transfer.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{transfer.user}</p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light" onClick={() => {
                          setModalDetail(false);
                        }}>
                        Close</button>
                      <button
                        type="submit"
                        className="btn btn-info" onClick={() => {
                          handlePrint();
                        }}>Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />

              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={transfer} />
      </Container>
    </div>
  );
};

export default Transfer;
